<template>
  <div class="BodaccTab pt-5 overflow-y-scroll">
    <div
      v-if="isLoading"
      class="flex w-full h-full justify-center items-center relative"
    >
      <Loader />
    </div>
    <DataTable
      v-else-if="data.length"
      :rows="data"
      :columns="columns"
      cell-padding="p-0"
    >
      <template #date="{ row }">
        <p v-if="row.releasedAt" class="text-left">
          {{ moment.utc(row.releasedAt).format('L') }}
        </p>
        <p v-else class="text-left">-</p>
      </template>
      <template #publicationAvis="{ row }">
        <p v-if="row.releasedType" class="text-left">
          {{ row.releasedType }}
        </p>
        <p v-else class="text-left">-</p>
      </template>
      <template #type="{ row }">
        <p v-if="row.type" class="text-left">
          {{ row.type.descriptif }}
        </p>
        <p v-else class="text-left">-</p>
      </template>
      <template #id="{ row }">
        <p v-if="row.id" class="text-left">
          {{ row.id }}
        </p>
        <p v-else class="text-left">-</p>
      </template>
      <template #details="{ row }">
        <div v-if="row.persons.personne.administration">
          <p
            v-for="(elm, index) in row.persons.personne.administration.split(
              ';'
            )"
            :key="index"
            class="text-left"
          >
            {{ elm }}
          </p>
        </div>
      </template>
      <template #createdAt="{ row }">
        <p v-if="row.createdAt" class="text-left">
          {{ moment.utc(row.createdAt).format('L') }}
        </p>
        <p v-else class="text-left">-</p>
      </template>

      <template #actions="{ row }">
        <div class="flex justify-end">
          <a
            :href="getLink(row)"
            target="_blank"
            rel="noopener noreferrer"
            class="p-2 rounded bg-primary5 text-white"
            >PDF</a
          >
        </div>
      </template>
    </DataTable>
    <div v-else class="flex justify-center items-center w-full mt-4">
      <EmptyState
        class="d-block mx-auto datatable"
        :title="$t('global.noResult')"
        subtitle=""
      />
    </div>
  </div>
</template>

<script lang="ts">
  import { computed, defineComponent, onMounted, watch } from 'vue'
  import DataTable from '@/components/DataTable/index.vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'
  import moment from 'moment'
  import { useI18n } from 'vue-i18n'
  import Loader from '@/components/Loader/index.vue'
  import EmptyState from '@/components/EmptyState/index.vue'

  export default defineComponent({
    name: 'BodaccTab',
    components: { DataTable, Loader, EmptyState },
    props: {},
    setup() {
      const store = useStore()
      const route = useRoute()
      const { t } = useI18n()
      const isLoading = computed(
        () => store.getters['organizations/isLoadingCompanyData']
      )
      const columns = computed(() => [
        {
          label: 'Date',
          field: 'date',
          custom: true,
          width: '5%'
        },
        {
          label: 'Type',
          field: 'publicationAvis',
          custom: true,
          width: '2%'
        },
        {
          label: t('datatable.column.publicationNumber'),
          field: 'id',
          custom: true,
          width: '2%'
        },
        {
          label: t('datatable.column.registerDate'),
          field: 'createdAt',
          custom: true,
          width: '5%'
        },
        {
          label: t('datatable.column.publication'),
          field: 'type',
          width: '30%',
          custom: true
        },
        {
          label: t('datatable.column.details'),
          field: 'details',
          width: '30%',
          custom: true
        },
        {
          label: '',
          field: 'actions',
          width: '10%',
          custom: true
        }
      ])
      const bodacc = computed(() => store.getters['organizations/bodac'])
      const data = computed(() =>
        [...bodacc.value].sort((a: any, b: any) =>
          moment(b.releasedAt).diff(moment(a.releasedAt))
        )
      )

      const getLink = (data: any) => {
        const [year] = data.releasedAt.split('-')
        const base = `https://fr.ftp.opendatasoft.com/datadila/BODACC/COMMERCIALES/PDF/`
        if (year < 2017) {
          return `${base}${data.releasedType}/BODACC-${data.releasedType}_${data.release}_0001_p000.pdf`
        }
        const link = `${base}${data.releasedType}/${year}/${data.release}/${
          data.folder
        }/BODACC_${data.releasedType}_PDF_Unitaire_${data.release}_${data.adId
          .toString()
          .padStart(5, '0')}.pdf`
        return link
      }
      watch(
        () => route.params.id,
        (val: any) => {
          store.dispatch('organizations/GET_BODAC', {
            companyId: val
          })
        }
      )
      onMounted(() => {
        store.dispatch('organizations/GET_BODAC', {
          companyId: route.params.id
        })
      })

      return { columns, data, moment, isLoading, getLink }
    }
  })
</script>

<style scoped></style>
